<template>
    <div id="app">
        
        <Chat></Chat>
    </div>
</template>

<script>
    import Chat from './components/Chat.vue'
    export default {
        name: 'App',
        components: {
            Chat,
        },
       created(){
         this.getVsit();
       },
       methods: {
            //获取访问量
    async getVsit() {
     
        var userToken = JSON.parse(
          localStorage.getItem("user_info")
        ).user_token;
        var fullPath = !localStorage.getItem("fullPath") ? '/':localStorage.getItem("fullPath")
        var data = {
          signField: ["url", "pre_url", "url_name"],
          url:'/znkf',
          pre_url:  fullPath ,
          url_name: "智能客服",
          user_token: userToken,
        };
       await this.$api.get("/visitor/visit", data);
    },
       }
    }
</script>

<style scoped>

</style>
